import * as React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Sheet,
    YStack,
} from 'smoothie';

interface InviteSheetProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    confirmButtonDisabled: boolean;
    partnerMemberFullName: string;
    partnerMemberEmail: string;
}

const InviteSheet = ({
    isOpen,
    onClose,
    onConfirm,
    confirmButtonDisabled,
    partnerMemberFullName,
    partnerMemberEmail,
}: InviteSheetProps) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            title="Invite account owner"
            showCloseButton
        >
            <YStack alignItems="center">
                <BodyMediumRegular textAlign="center" marginBottom={12}>
                    You are about to invite {partnerMemberFullName} to be an
                    account owner on your Fruitful Cash Account.
                </BodyMediumRegular>
                <BodyMediumRegular textAlign="center" marginBottom={24}>
                    Confirm to send an invite via email to {partnerMemberEmail}.
                </BodyMediumRegular>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Confirm"
                    onPress={onConfirm}
                    disabled={confirmButtonDisabled}
                />
            </YStack>
        </Sheet>
    );
};

export default InviteSheet;
